<template>
    <form method="POST" :action="route" @submit="checkForm" class="w-100">
        <input type="hidden" name="_token" :value="token">
            <table class="myfotable">
                <thead>
                    <tr>
                        <th scope="col" style="width:20%;">Plateforme</th>
                        <th scope="col" style="width:11%;">Contrat</th>
                        <th scope="col" style="width:11%;">Type</th>
                        <th scope="col" style="width:11%;">ISIN</th>
                        <th scope="col" style="width:11%;">Quantité</th>
                        <th scope="col" style="width:11%;">Montant</th>
                        <th scope="col" style="width:11%;">Devise</th>
                        <th scope="col" style="width:11%;">Date</th>
                        <th scope="col" style="width:3%;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(raw, index) in form" :key="index">
                        <td style="width: 20%;" class="pl-3">
                            <select
                                style="text-align: center;"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].platform) : false}"
                                v-model="raw.platform"
                                @change="onPlatformChange(raw)"
                                :disabled="raw.disabled">
                                <option value="" disabled>Platforme</option>
                                <option v-for="platform in platforms" :key="platform.id" :value="platform.id">{{ platform.name }}</option>
                            </select>
                        </td>
                        <td style="width: 11%;">
                            <select
                                style="text-align:center;"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].contract) : false}"
                                v-model="raw.contract"
                                @change="onContractChange(raw)"
                                :disabled="raw.disabled">
                                <option value="" disabled>Contrat</option>
                                <option v-for="contract in raw.contracts" :key="contract.id" :value="contract.id">{{ contract.name }}</option>
                            </select>
                        </td>
                        <input class="fts-12" type="hidden" :name="'form[' + index + '][platform_contract]'" v-model="raw.platform_contract" :disabled="raw.disabled">
                        <td style="width: 11%;">
                            <select
                                style="text-align:center;"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].type) : false}"
                                :name="'form[' + index + '][type]'"
                                v-model="raw.type"
                                @change="onTypeChange(raw)"
                                :disabled="raw.disabled">
                                <option value='' disabled>Type</option>
                                <option value='0'>Liquidité</option>
                                <option value='1'>Placement</option>
                            </select>
                        </td>
                        <td style="width: 11%;">
                            <select
                                style="text-align:center;"
                                v-if="raw.type == '0'"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].isin) : false}"
                                :name="'form[' + index + '][isin]'"
                                v-model="raw.isin"
                                :disabled="raw.disabled">
                                <option value='' disabled>ISIN</option>
                                <option v-for="isin in raw.isins" :key="isin.id" :value="isin.isin">{{ isin.name }}</option>
                            </select>

                            <input
                                v-if="raw.type == '1'"
                                type="text"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].isin) : false}"
                                :name="'form[' + index + '][isin]'"
                                placeholder="Code ISIN"
                                v-model="raw.isin"
                                :disabled="raw.disabled">
                        </td>
                        <td style="width: 11%;">
                            <input class="fts-12" type="hidden" :name="'form[' + index + '][quantity]'" value="1" :disabled="raw.disabled">
                            <input
                                style="text-align:center;"
                                v-if="getContractQuantityType(raw.contract) != '1' && raw.type == '1'"
                                type="number"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].quantity) : false}"
                                min="0"
                                :name="'form[' + index + '][quantity]'"
                                v-model="raw.quantity"
                                :disabled="raw.disabled">
                        </td>
                        <td style="width: 11%;">
                            <input
                                style="text-align:center;"
                                type="number"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].amount) : false}"
                                min="0"
                                step="0.01"
                                :name="'form[' + index + '][amount]'"
                                v-model="raw.amount"
                                :disabled="raw.disabled">
                        </td>
                        <td style="width: 11%;">
                            <select
                                style="text-align:center;"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].currency) : false}"
                                :name="'form[' + index + '][currency]'"
                                v-model="raw.currency"
                                :disabled="raw.disabled">
                                <option value="" disabled>Devise</option>
                                <option v-for="currency in currencies" :key="currency.id" :value="currency.id">{{ currency.code }}</option>
                            </select>
                        </td>
                        <td style="width: 11%;">
                            <input
                                style="text-align:center;"
                                type="date"
                                class="form-control fts-12"
                                :class="{ 'is-invalid' : errors[index] ? (errors[index].date) : false}"
                                 :name="'form[' + index + '][date]'"
                                v-model="raw.date"
                                :disabled="raw.disabled">
                        </td>
                        <td style="width: 3%;">
                            <button
                                style="text-align:center; color: red;"
                                v-if="!raw.disabled"
                                type="button"
                                class="close fts-12"
                                aria-label="Close"
                                v-on:click="form.splice(form.indexOf(raw), 1)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row justify-content-center text-center my-4">
                <button type="button" class="btn-myfo-blue mr-3" v-on:click="addRaw">Rajouter une position</button>
                <button type="submit" class="btn-myfo-blue triggerspinner">Enregistrer</button>
                <!-- <a class="btn btn-myfo" :href="periodicity" role="button">Gérer les périodicités</a> -->
            </div>
    </form>
</template>

<script>
    export default {
        props: [
            'platforms_contracts',
            'currencies',
            'investments',
            'route',
            'periodicity',
            'token'
        ],

        data() {
            return {
                platforms : [],
                form: [],
                errors: []
            }
        },

        mounted() {
            this.platforms_contracts.forEach(platform_contract =>
            {
                if (!this.platforms.find(element => element.id == platform_contract.platform.id))
                {
                    this.platforms.push(platform_contract.platform);
                }
            });

            this.investments.forEach(investment =>
            {
                var raw = this.createRaw(true);
                raw.platform = investment.platform_contract.platform.id.toString();
                this.onPlatformChange(raw);
                raw.contract = investment.platform_contract.contract.id.toString();
                this.onContractChange(raw);
                raw.type = investment.type.toString();
                this.onTypeChange(raw);
                raw.isin = investment.isin.toString();
                raw.quantity = investment.quantity.toString();
                raw.amount = investment.amount.toString();
                raw.currency = investment.currency.id.toString();
                raw.date = investment.date.toString();

                this.form.push(raw);
            });
        },

        methods: {

            createRaw(disabled){
                return  {
                        disabled: disabled,
                        platform: '',
                        contracts:[],
                        contract: '',
                        platform_contract: '',
                        type: '',
                        isins: [],
                        isin: '',
                        quantity: 1,
                        amount: 0,
                        currency: '',
                        date: '',
                    }
            },

            onPlatformChange(raw) {
                raw.contract = '';
                raw.type = '';
                raw.isin = '';

                raw.contracts = [];
                this.platforms_contracts.forEach(platform_contract => {
                    if (raw.platform == platform_contract.platform.id)
                    {
                        raw.contracts.push(platform_contract.contract);
                    }
                });
            },

            onContractChange(raw) {
                raw.type = '';
                raw.isin = '';

                raw.isins = [];
                this.platforms_contracts.forEach(platform_contract => {
                    if (raw.platform == platform_contract.platform.id && raw.contract == platform_contract.contract.id)
                    {
                        raw.platform_contract = platform_contract.id;
                        raw.isins = platform_contract.isin_cash;
                    }
                });
            },

            onTypeChange(raw) {
                raw.isin = '';
            },

            getContractQuantityType(contract)
            {
                var type = null;
                for (let platform_contract of this.platforms_contracts)
                {
                    if (platform_contract.contract.id == contract)
                    {
                        type = platform_contract.contract.quantity_type;
                        break;
                    }
                }
                return type;
            },

            addRaw() {
                this.form.push(this.createRaw(false))
            },

            checkForm(event) {
                var ok = true

                this.errors = []
                this.form.forEach(investment => {
                    this.errors.push({
                            platform: !investment.platform,
                            contract: !investment.contract,
                            type: !investment.type,
                            isin: !(investment.isin && (investment.type == '0' || (investment.type == '1' && /[A-Z]{2}[A-Z0-9]{9}[0-9]{1}/.exec(investment.isin)))),
                            quantity: this.getContractQuantityType(investment.contract) == '1' && investment.type == '1' && investment.quantity == 1,
                            amount: investment.amount == 0,
                            currency: !investment.currency,
                            date: !(new Date(investment.date) <= new Date()),
                        })
                        var inv = this.errors[this.errors.length - 1]
                        ok = !(!ok || inv.platform || inv.contract || inv.type || inv.isin || inv.quantity || inv.amount || inv.currency || inv.date)
                    }
                )

                if (!ok)
                {
                    event.preventDefault()
                }
            }
        }
    }

</script>

